import locationService from '@/api/location'
import { LOCATION_SET } from '../types'

export default {
  namespaced: true,
  state: {
    locations: []
  },
  getters: {
  },
  mutations: {
    [LOCATION_SET] (state, locations) {
      state.locations = locations
    }
  },
  actions: {
    getLocationsList: function ({commit, dispatch}) {
      return new Promise((resolve, reject) => {
        locationService.getLocals().then((response) => {
          commit(LOCATION_SET, response.data)
          resolve()
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    },
    addLocation: function ({dispatch}, location) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        locationService.addLocal(location).then(() => {
          dispatch('getLocationsList').then(() => {
            resolve()
          }).catch((error) => {
            reject(error)
          })
        })
      })
    },
    editLocation: function ({dispatch}, location) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        locationService.editLocal(location).then(() => {
          dispatch('getLocationsList').then(() => {
            resolve()
          }).catch((error) => {
            reject(error)
          })
        })
      })
    },
    deleteLocation: function ({dispatch}, id) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        locationService.deleteLocal(id).then(() => {
          dispatch('getLocationsList').then(() => {
            resolve()
          }).catch((error) => {
            reject(error)
          })
        })
      })
    }
  }
}
